// oxlint-disable-next-line no-restricted-imports -- TODO(zod-4): migrate to 'zod/v4'
import { z } from 'zod';

import { useEnvironmentMode } from './useEnvironmentMode';
import { useRootEnvironmentMode } from './useRootEnvironmentMode';

const environmentSelectorPositionSchema = z.enum(['inside-tab-panel', 'outside-tab-panel']);

type EnvironmentSelectorPosition = z.infer<typeof environmentSelectorPositionSchema>;

/**
 * Determines the environment selector position based on entity scope and mode.
 * Returns undefined when no environment selector should be shown.
 */
export function useEnvironmentSelectorPosition(): EnvironmentSelectorPosition | undefined {
  const environmentMode = useEnvironmentMode();
  const rootEnvironmentMode = useRootEnvironmentMode();

  // Don't show selector for 'all' mode
  if (environmentMode === 'all') {
    return undefined;
  }

  // Environment-scoped entities (like experiments) show selector outside tabs
  const isEnvironmentScopedEntity = rootEnvironmentMode === 'single';

  return isEnvironmentScopedEntity ? 'outside-tab-panel' : 'inside-tab-panel';
}
